interface GalleryImage {
  url: string;
  alt?: string;
  caption?: string;
}

interface GalleryProps {
  images?: GalleryImage[];
  columns?: '2' | '3' | '4';
  gap?: 'none' | 'sm' | 'md' | 'lg';
  aspectRatio?: 'square' | 'landscape' | 'portrait' | 'auto';
}

const GAP_MAP: Record<string, string> = { none: 'gap-0', sm: 'gap-2', md: 'gap-4', lg: 'gap-6' };
const ASPECT_MAP: Record<string, string> = { square: 'aspect-square', landscape: 'aspect-video', portrait: 'aspect-[3/4]', auto: '' };

export function GalleryBlock({ props }: { props: GalleryProps }) {
  const images = props.images ?? [];
  if (images.length === 0) return null;
  const cols = props.columns ?? '3';
  const gap = GAP_MAP[props.gap ?? 'md'] ?? 'gap-4';
  const aspect = ASPECT_MAP[props.aspectRatio ?? 'square'] ?? 'aspect-square';

  return (
    <div className={`grid ${gap} ${cols === '2' ? 'grid-cols-2' : cols === '4' ? 'grid-cols-2 sm:grid-cols-4' : 'grid-cols-2 sm:grid-cols-3'}`}>
      {images.map((img, i) => (
        <figure key={i} className="overflow-hidden rounded-lg">
          <img src={img.url} alt={img.alt ?? ''} className={`w-full object-cover ${aspect}`} loading="lazy" decoding="async" />
          {img.caption && <figcaption className="text-xs text-zinc-500 mt-1 px-1">{img.caption}</figcaption>}
        </figure>
      ))}
    </div>
  );
}
